import Courses from './Pages/Courses/Courses';
import Login from './Pages/Login/Login';
import LoginOrProfile from './Pages/Login/LoginOrProfile';
import Problems from './Pages/SearchProblems/Problems';
import ProblemPage from './Pages/SolveProblem/SolvePage';
import SolveMCQ from './Pages/SolveProblem/MCQ/SolveMCQ';
import ForgotPassword from './Pages/CustomerSupport/ForgotPassword';
import './global.css'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Problems/>}/>
        <Route path='/Profile' element={<LoginOrProfile/>}/>
        <Route path='/Courses' element={<Courses/>}/>
        <Route path='/ProblemCode' element={<ProblemPage/>}/>
        <Route path='/ProblemMCQ' element={<SolveMCQ/>}/>
        <Route path='/ForgotPassword' element={<ForgotPassword/>}/>
      </Routes>
    </Router>
  );
}

export default App; 
